angular.module('SpidApp')

.factory('Product', [function () {
	var Product = function (params) {
		params = params || {}

		this.id         = params.id
		this.label      = params.label
		this.category   = params.category
		this.code_tva   = params.code_tva
		this.price      = params.price
		this.barcode    = params.barcode
		this.equinox    = params.equinox
	}
	
	return Product
}])